export const styles = {
    wrapper: {
        width: "100%",
        height: "calc(100% - 54px)"
    },
    sidebarContainer: {
        height: "100%",
        transition: "width 0.4s ease",
        backgroundColor: "greyscale.50",
        padding: ({ spacing }) => spacing(3),
        borderTopRightRadius: ({ spacing }) => spacing(1),
        borderBottomRightRadius: ({ spacing }) => spacing(1),
        overflowX: "hidden",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "greyscale.200",
        borderLeft: "none"
    },
    contentContainer: {
        height: "100%",
        flex: 1
    },
    icon: {
        fontSize: 20,
        marginBottom: 1
    }
};
